var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDownRoundOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "black",
    fillRule: "nonzero",
    d: "M256 0c70.68,0 134.7,28.66 181.02,74.98 46.32,46.32 74.98,110.33 74.98,181.02 0,70.69 -28.66,134.7 -74.98,181.02 -46.32,46.32 -110.33,74.98 -181.02,74.98 -70.69,0 -134.7,-28.66 -181.02,-74.98 -46.32,-46.32 -74.98,-110.33 -74.98,-181.02 0,-70.69 28.66,-134.7 74.98,-181.02 46.32,-46.32 110.33,-74.98 181.02,-74.98zm-109.04 227.91l109.04 109.03 109.04 -109.03 -40.51 -40.52 -68.52 68.51 -68.52 -68.52 -40.53 40.53zm264.03 -126.9c-39.66,-39.66 -94.47,-64.2 -154.99,-64.2 -60.53,0 -115.33,24.54 -154.99,64.2 -39.66,39.66 -64.2,94.46 -64.2,154.99 0,60.53 24.54,115.33 64.2,154.99 39.66,39.66 94.46,64.2 154.99,64.2 60.53,0 115.33,-24.54 154.99,-64.2 39.66,-39.66 64.2,-94.46 64.2,-154.99 0,-60.53 -24.54,-115.33 -64.2,-154.99z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownRoundOutline);
export default __webpack_public_path__ + "static/media/arrow-down-round-outline.4ff33c04efddbb7ad19d856078672cb3.svg";
export { ForwardRef as ReactComponent };